export default {
    namespaced: true,
    state: {
        /**
         * 选择的案件ID集合
         */
        caseIdList: [],
        /**
         * 选择联系人弹框打开状态
         */
        relationState: false,
        /**
         * 选中的发送对象
         */
        checkRelation: [],
    },
    mutations: {
        updateCaseIdList: function (state, data) {
            state.caseIdList = data;
        },
        updateRelationState: function (state, data) {
            state.relationState = data;
        },
        updateCheckRelation: function (state, data) {
            state.checkRelation = data;
        }
    },
    actions: {
        updateCaseIdList: function (_a, caseIdList) {
            var commit = _a.commit;
            commit('updateCaseIdList', caseIdList);
        },
        updateRelationState: function (_a, state) {
            var commit = _a.commit;
            commit('updateRelationState', state);
        },
        updateCheckRelation: function (_a, checkRelation) {
            var commit = _a.commit;
            commit('updateCheckRelation', checkRelation);
        }
    }
};
